<template>
    <Modal v-model="visible" width="400px" :footer-hide="true" :mask-closable="false" class="my-modal">
        <Form ref="form" :model="formParams" class="page-form less" v-if="visible" label-position="top">
            <FormItem prop="demandVal" label="请选择您的对接需求" class="full" :rules="$units.formRule.required('请选择', 'change')">
                <RadioGroup v-model="formParams.demandVal">
                    <Radio v-for="item in demandList" :key="item.value" :label="item.value">
                        <span>{{item.label}}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false">取消</Button>
            <Button type="primary" @click="submit" :loading="loading">提交</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    mixins: [],
    components: {},
    data() {
        return {
            demandList: [
                {
                    label:'api在线对接',
                    value:'1'
                },
                {
                    label:'计划书',
                    value:'2'
                },
                {
                    label:'api在线投保+计划书',
                    value:'3'
                },
            ],
            visible: false,
            loading: false,
            formParams: {
            }
        };
    },
    watch: {
        visible(newVal) {
            if (!newVal) {
                this.$refs.form.resetFields();
            }
        }
    },
    created() { },
    methods: {
        open(row = {}) {
            this.formParams.id = row.id;
            this.visible = true;
        },
        submit() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                this.$http({
                    type: 'POST',
                    url: '/buz/continuityRateRecord/startCalculation',
                    data: this.formParams
                })
                    .then(() => {
                        this.$notice.success('操作成功');
                        this.visible = false;
                        this.$emit('success');
                    })
                    .finally(res => {
                        this.loading = false;
                    });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.my-modal {
    /deep/ {
        .ivu-checkbox-inner {
            top: -1px;
        }

        .ivu-checkbox-group-item {
            width: 25%;
            margin-right: 0;
        }
    }
}

.tab-box {
    position: relative;
    margin-bottom: 10px;

    .tab-name {
        position: absolute;
        left: 0;
        top: 11px;
        z-index: 1;
        font-size: 14px;
        font-weight: bold;
    }

    /deep/ {
        .ivu-tabs-nav {
            padding-left: 120px;
        }
    }
}
</style>
